import PropTypes from "prop-types";
import styles from "./LeftWrap.module.css";

const LeftWrap = (props) => {
  return <div className={styles.leftWrap}>{props.children}</div>;
};

LeftWrap.propTypes = {
  children: PropTypes.node,
};

export default LeftWrap;
